import { Button, Form, Input, InputNumber, Select } from 'antd';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function BenefitForm() {
    const token = useSelector((state) => state.user.token);
    const location = useLocation();
    const navigate = useNavigate();
    const [levelDetail, setLevelDetail] = useState();
    const [form] = Form.useForm();

    const train = [
        { value: 3, label: "Economy Class" },
        { value: 4, label: "Business Class" },
        { value: 5, label: "Executive Class" },
    ];

    const plane = [
        { value: 2, label: "Economy Class (Premium Airline)" },
        { value: 1, label: "Economy Class (LCC)" },
    ];

    useEffect(() => {
        if (location.state != null) {
            const item = location.state.item;
            form.setFieldsValue({
                level_detail_id: item.level_detail_id,
                plane: item.benefit_transportation[0].transportation_id,
                train: item.benefit_transportation[1].transportation_id,
                pocket_1: item.pockey_money[0].budget,
                pocket_2: item.pockey_money[1].budget,
                pocket_3: item.pockey_money[2].budget,
                lodging_price: item.lodging_price,
                join_visit_price: item.join_visit_price,
                entertainment_price: item.entertainment_price
            });
        }
        getApi('/leveldetail?nopage=true', 'leveldetail');
    }, []);

    const getApi = (url, type) => {
        const dataReq = {
            method: "GET",
            url: url,
            data: {
                headers: { Authorization: 'Bearer ' + token }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                if (type === 'leveldetail') {
                    const row = res.data.data.map(item => ({
                        value: item.level_detail_id,
                        label: item.name,
                    }));
                    setLevelDetail(row);
                }
            } else {
                console.error(res.message);
            }
        }).catch((e) => {
            console.error(e.message);
        });
    };

    const save = async (ev) => {
        const pocket = [
            { status: "Domestic", budget: ev.pocket_1, currency: "Rupiah" },
            { status: "International (Asia)", budget: ev.pocket_2, currency: "USD" },
            { status: "International (Non Asia)", budget: ev.pocket_3, currency: "USD" },
        ];

        const transportation = [
            { transportation_id: ev.plane },
            { transportation_id: ev.train },
            { transportation_id: 6 },
            { transportation_id: 7 },
            { transportation_id: 8 }
        ];

        ev.pocket_money = pocket;
        ev.transportation = transportation;
        delete ev.pocket_1;
        delete ev.pocket_2;
        delete ev.pocket_3;
        delete ev.plane;
        delete ev.train;

        if (location.state != null) {
            const item = location.state.item;
            postApi("PUT", '/benefitlevel/' + item.benefit_id, ev);
        } else {
            postApi("POST", '/benefitlevel', ev);
        }
    };

    const postApi = (method, url, values) => {
        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: { Authorization: 'Bearer ' + token }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                navigate(-1);
            } else {
                modalError(res.message);
            }
        }).catch((e) => {
            console.error(e);
        });
    };

    return (
        <div>
            <h3>Benefit Form</h3>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" onClick={form.submit} size='large'>
                    <b style={{ marginLeft: 5 }}>Save</b>
                </Button>
            </div>
            <Form form={form} name="form_store" layout="vertical" onFinish={save}>
                <Form.Item
                    name="level_detail_id"
                    label="Select Level"
                    rules={[{ required: true, message: 'Level is required!' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select Level"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                        filterSort={(a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())}
                        options={levelDetail}
                    />
                </Form.Item>

                <h4>Transportation</h4>
                <Form.Item
                    name="plane"
                    label="Plane Class"
                    rules={[{ required: true, message: 'Plane class is required!' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select Plane Class"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                        filterSort={(a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())}
                        options={plane}
                    />
                </Form.Item>
                <Form.Item
                    name="train"
                    label="Train Class"
                    rules={[{ required: true, message: 'Train class is required!' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select Train Class"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                        filterSort={(a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())}
                        options={train}
                    />
                </Form.Item>

                <h4>Pocket Money</h4>
                <Form.Item
                    name="pocket_1"
                    label="Domestic (IDR)"
                    rules={[{ required: true, message: 'Domestic (IDR) is required!' }]}
                >
                    <InputNumber
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                        style={{ width: '100%' }}
                        placeholder='Domestic (IDR)'
                    />
                </Form.Item>
                <Form.Item
                    name="pocket_2"
                    label="International (Asia) (USD)"
                    rules={[{ required: true, message: 'International (Asia) is required!' }]}
                >
                    <InputNumber
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                        style={{ width: '100%' }}
                        placeholder='International (Asia)' />
                </Form.Item>
                <Form.Item
                    name="pocket_3"
                    label="International (Non Asia) (USD)"
                    rules={[{ required: true, message: 'International (Non Asia) is required!' }]}
                >
                    <InputNumber
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                        style={{ width: '100%' }}
                        placeholder='International (Non Asia)' />
                </Form.Item>

                <h4>Others</h4>
                <Form.Item
                    name="lodging_price"
                    label="Lodging Budget"
                    rules={[{ required: true, message: 'Lodging budget is required!' }]}
                >
                    <InputNumber
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                        style={{ width: '100%' }}
                        placeholder='Lodging Budget' />
                </Form.Item>
                <Form.Item
                    name="join_visit_price"
                    label="Join Visit Budget"
                    rules={[{ required: true, message: 'Join visit budget is required!' }]}
                >
                    <InputNumber
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                        style={{ width: '100%' }}
                        placeholder='Join Visit Budget' />
                </Form.Item>
                <Form.Item
                    name="entertainment_price"
                    label="Entertainment Budget"
                    rules={[{ required: true, message: 'Entertainment budget is required!' }]}
                >
                    <InputNumber
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                        style={{ width: '100%' }}
                        placeholder='Entertainment Budget' />
                </Form.Item>
            </Form>
        </div>
    );
}

export default BenefitForm;
